import React, { useEffect } from 'react'
const nodemailer=require('nodemailer')



function VerifyDonation() {
    useEffect(()=>{

    },[])

    return (
        <div>
            <h1>ENTER OTP:</h1>
            <input type="text">  </input>
        </div>
    )
}



export default VerifyDonation
